export function NotFoundPage(): JSX.Element {
  return (
    <h1
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'absolute',
        inset: 0,
        color: 'white',
        textAlign: 'center'
      }}
    >
      Erro 404, conteúdo não encontrado.
    </h1>
  )
}
